import datapoints from '../datapoints';
import { PerformanceDatapoint } from 'owa-analytics';
import { trace } from 'owa-trace';
export default function logEditorPerf(perfData) {
    var data = {};
    var consoleLog = 'Editor Typing Perf:\n';
    for (var _i = 0, _a = Object.keys(perfData); _i < _a.length; _i++) {
        var key = _a[_i];
        var perfEntry = perfData[key];
        var average = perfEntry.totalTime / perfEntry.count;
        data[key] = average;
        consoleLog += key + ":{" + perfEntry.totalTime + "/" + perfEntry.count + "=" + average + "}\n";
    }
    var perfDatapoint = new PerformanceDatapoint(datapoints.EditorTypingPerf.datapoint.name);
    perfDatapoint.addCustomData(data);
    perfDatapoint.end();
    if (consoleLog != '') {
        trace.info(consoleLog);
    }
}
//# sourceMappingURL=logEditorPerf.js.map